export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10932.bdb10cef.jpg";